import React from 'react';
import { Check, X } from 'lucide-react';
interface PricingCardProps {
  name: string;
  price: string;
  originalPrice: string;
  features: string[];
  link: string;
  isDeluxe?: boolean;
  isVip?: boolean;
  icon: string;
  bonusFeatures?: {
    title: string;
    items: string[];
  }[];
  packImage?: string;
  notIncluded?: string[];
  badgeText?: string;
}
export function PricingCard({
  name,
  price,
  originalPrice,
  features,
  link,
  isDeluxe = false,
  isVip = false,
  icon,
  bonusFeatures,
  packImage,
  notIncluded,
  badgeText
}: PricingCardProps) {
  const getBorderColor = () => {
    if (isVip) return 'border-purple-500';
    if (isDeluxe) return 'border-[#F59E0B]';
    return 'border-gray-200';
  };
  const getBackgroundColor = () => {
    if (isVip) return 'bg-gradient-to-b from-purple-950 to-black';
    if (isDeluxe) return 'bg-gradient-to-b from-gray-900 to-black';
    return 'bg-white';
  };
  const getShadow = () => {
    if (isVip) return 'shadow-[0_0_30px_rgba(168,85,247,0.4)]';
    if (isDeluxe) return 'shadow-[0_0_30px_rgba(245,158,11,0.3)]';
    return '';
  };
  return <div className={`relative flex flex-col h-full rounded-2xl transition-transform duration-300 border-2 ${getBorderColor()} ${getBackgroundColor()} ${getShadow()} ${isDeluxe || isVip ? 'scale-100 md:scale-105 z-10' : ''}`} data-id="element-9">
      {isDeluxe && badgeText && <div className={`absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F59E0B] text-black font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider shadow-lg whitespace-nowrap`} data-id="element-10">
          {badgeText}
        </div>}

      <div className="p-8 flex-grow" data-id="element-11">
        <div className="text-center mb-8" data-id="element-12">
          <div className="text-4xl mb-4" data-id="element-13">{icon}</div>
          <h3 className={`text-2xl font-bold mb-2 ${isDeluxe || isVip ? 'text-white' : 'text-black'}`} data-id="element-14">
            {name}
          </h3>

          {packImage && <div className="my-6" data-id="element-15">
              <img src={packImage} alt={name} className="w-full h-auto rounded-lg" data-id="element-16" />
            </div>}

          <div className="flex flex-col items-center justify-center" data-id="element-17">
            <span className={`text-lg line-through ${isDeluxe || isVip ? 'text-gray-500' : 'text-gray-400'}`} data-id="element-18">
              {originalPrice}
            </span>
            <span className={`text-4xl font-bold ${isVip ? 'text-purple-400' : 'text-[#F59E0B]'}`} data-id="element-19">
              {price}
            </span>
          </div>
        </div>

        <ul className="space-y-4 mb-8" data-id="element-20">
          {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-21">
              <Check className={`w-5 h-5 flex-shrink-0 mt-0.5 ${isDeluxe || isVip ? isVip ? 'text-purple-400' : 'text-[#F59E0B]' : 'text-green-600'}`} data-id="element-22" />
              <span className={`text-sm ${isDeluxe || isVip ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-23">
                {feature}
              </span>
            </li>)}
        </ul>

        {notIncluded && notIncluded.length > 0 && <div className="mb-8 pt-6 border-t border-gray-200" data-id="element-24">
            <ul className="space-y-3" data-id="element-25">
              {notIncluded.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-26">
                  <X className="w-5 h-5 flex-shrink-0 mt-0.5 text-red-500" data-id="element-27" />
                  <span className="text-sm text-gray-600" data-id="element-28">{item}</span>
                </li>)}
            </ul>
          </div>}

        {bonusFeatures && <div className="mt-8 pt-8 border-t border-gray-800" data-id="element-29">
            <p className={`${isVip ? 'text-purple-400' : 'text-[#F59E0B]'} font-bold mb-4 text-center uppercase tracking-wide`} data-id="element-30">
              y además...
            </p>
            <div className="space-y-6" data-id="element-31">
              {bonusFeatures.map((group, idx) => <div key={idx} data-id="element-32">
                  <h4 className="text-white font-bold mb-2 flex items-center gap-2" data-id="element-33">
                    {group.title}
                  </h4>
                  <ul className="space-y-2 pl-6" data-id="element-34">
                    {group.items.map((item, itemIdx) => <li key={itemIdx} className="text-gray-400 text-sm list-disc" data-id="element-35">
                        {item}
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>}
      </div>

      <div className="p-8 pt-0 mt-auto" data-id="element-36">
        <a href={link} className={`block w-full py-4 px-6 rounded-xl font-bold text-center text-lg transition-all duration-200 transform hover:-translate-y-1 ${isVip ? 'bg-purple-600 text-white hover:bg-purple-700 shadow-lg shadow-purple-500/20' : isDeluxe || !isDeluxe ? 'bg-[#F59E0B] text-black hover:bg-[#d98a06] shadow-lg' : 'bg-[#F59E0B] text-black hover:bg-[#d98a06] shadow-lg'}`} data-id="element-37">
          Quiero empezar ahora
        </a>
      </div>
    </div>;
}